module.exports = __webpack_public_path__ + "img/add-user_1.ffa71cb1.png";